<ng-container *ngIf="!this.loaded">
  <boma-anim-spinning-loader [size]="80"></boma-anim-spinning-loader>
</ng-container>
<!-- this.definitions -->

<p-toast></p-toast>

<ng-container *ngIf="loaded">
  <p-tabMenu
    [scrollable]="true"
    [activeItem]="items[0]"
    [model]="items"
  ></p-tabMenu>
  <!-- MultiSelect Version (Tree Version disabled for now) -->

  <div
    *ngIf="definitions?.length > 0; else noDefinitions"
    [ngClass]="{
      ' grid p-3': showLabels
    }"
  >
    <div *ngIf="isDeveloperMode" class="col-12">
      {{ currentDefinitions | json }}
    </div>

    <ng-container *ngIf="showLabels">
      <div class="col-12 md:col-4 mt-2">
        <h5>Parent Grouping</h5>
      </div>
      <div class="col-10 md:col-8 mt-2">
        <h5>Child Grouping</h5>
      </div>
    </ng-container>

    <ng-container *ngFor="let definition of definitions">
      <!--      TODO migrate to vertical when have time to do multiple layouts-->
      <ng-container *ngIf="layout == 'horizontal' || layout == 'vertical'">
        <div
          *ngIf="showLabels"
          class="col-12 md:col-4 my-2 flex align-items-center"
        >
          <div
            [pTooltip]="
              definition.data.value.toLowerCase() === 'brands' ||
              definition.data.value.toLowerCase() === 'brand' ||
              definition.data.value.toLowerCase() === 'departments' ||
              definition.data.value.toLowerCase() === 'department' ||
              definition.data.value.toLowerCase() === 'categories' ||
              definition.data.value.toLowerCase() === 'category'
                ? 'This is a required definition and cannot be renamed'
                : 'Edit the name of this definition or any of the children'
            "
          >
            <button
              (click)="editDefinition(definition.data)"
              [disabled]="
                definition.data.value.toLowerCase() === 'brand' ||
                definition.data.value.toLowerCase() === 'brands' ||
                definition.data.value.toLowerCase() === 'departments' ||
                definition.data.value.toLowerCase() === 'department' ||
                definition.data.value.toLowerCase() === 'categories' ||
                definition.data.value.toLowerCase() === 'category'
              "
              class="p-button-text p-button-secondary mr-2"
              icon="pi pi-pencil"
              pButton
              pRipple
            ></button>
          </div>

          <strong *ngIf="showLabels">{{ definition.data.value }}</strong>
        </div>

        <div [class]="!showLabels ? ' formgrid mt-3' : 'col-10 md:col-7'">
          <ng-container
            *ngIf="
              (departmentsLoaded && categoriesLoaded && brandsLoaded) ||
                selectedTarget !== 2;
              else loading
            "
          >
            <ng-container
              *ngIf="
                selectedTarget === 2 &&
                  (definition.data.value.toLowerCase() === 'departments' ||
                    definition.data.value.toLowerCase() === 'department' ||
                    definition.data.value.toLowerCase() === 'categories' ||
                    definition.data.value.toLowerCase() === 'category' ||
                    definition.data.value.toLowerCase() === 'brands' ||
                    definition.data.value.toLowerCase() === 'brand');
                else customDefinition
              "
            >
              <ng-container
                *ngIf="
                  definition.data.value.toLowerCase() === 'brands' ||
                  definition.data.value.toLowerCase() === 'brand'
                "
              >
                <div class="p-fluid">
                  <ng-container *ngIf="currentBrands">
                    <div class="col-12 p-0">
                      <p-multiSelect
                        (onChange)="updateOptions($event, this.currentBrands)"
                        [(ngModel)]="selectedBrandsOptions"
                        [defaultLabel]="'Select brands for product creation'"
                        [options]="brandOptions"
                        [selectedItemsLabel]="'{0} brands selected'"
                        [showToggleAll]="false"
                        filterMatchMode="contains"
                        optionLabel="name"
                      >
                      </p-multiSelect>
                      <small
                        >*Select specific brands you want to use for your
                        product creation. To use all don't select any.</small
                      >
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  definition.data.value.toLowerCase() === 'departments' ||
                  definition.data.value.toLowerCase() === 'department'
                "
              >
                <ng-container *ngIf="currentDepartments">
                  <div class="col-12 p-0 p-fluid">
                    <p-multiSelect
                      (onChange)="
                        updateOptions($event, this.currentDepartments)
                      "
                      [(ngModel)]="selectedDepartmentOptions"
                      [defaultLabel]="'Select Departments for product creation'"
                      [options]="departmentOptions"
                      [selectedItemsLabel]="'{0} departments selected'"
                      [showToggleAll]="false"
                      filterMatchMode="contains"
                      optionLabel="name"
                    >
                    </p-multiSelect>
                    <small
                      >*Select the departments you want available on product
                      create, leave empty for all.</small
                    >
                  </div>
                </ng-container>
              </ng-container>

              <ng-container
                *ngIf="
                  definition.data.value.toLowerCase() === 'categories' ||
                  definition.data.value.toLowerCase() === 'category'
                "
              >
                <ng-container *ngIf="currentCategories">
                  <div class="col-12 px-0 p-fluid">
                    <boma-category-selector
                      (updateCategories)="updateCategoryOptions($event)"
                      [multipleCategories]="true"
                      [placeholder]="'Search Categories'"
                    ></boma-category-selector>
                  </div>

                  <div class="col-12 px-0 p-fluid">
                    <ng-container
                      *ngIf="selectedTarget === 2 && selectedCategories"
                    >
                      <p-dropdown
                        [disabled]="!editing"
                        [options]="currentCategories.children"
                        [placeholder]="
                          'Categories (' +
                          currentCategories.children?.length +
                          ')'
                        "
                        optionLabel="value"
                      ></p-dropdown>
                      <small
                        >*Select specific categories you want to use for your
                        product creation and reports. To use all don't select
                        any.</small
                      >
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-template #customDefinition>
              <div class="p-fluid">
                <p-dropdown
                  #definitionSelector
                  (onChange)="
                    updateDefinitionSelection(
                      [definitionSelector.value],
                      definition.data.id
                    )
                  "
                  *ngIf="singleSelection"
                  [(ngModel)]="currentDefinitions[definition.data.id][0]"
                  [disabled]="!editing"
                  [options]="definition.children"
                  [placeholder]="
                    definition.data?.value +
                    ' (' +
                    definition.children?.length +
                    ')'
                  "
                  dataKey="id"
                  optionLabel="data.value"
                  optionValue="data"
                ></p-dropdown>

                <ng-container *ngIf="!singleSelection">
                  <p-multiSelect
                    #definitionSelector
                    (onClick)="
                      updateDefinitionSelection(
                        this.definitionSelector.value,
                        definition.data.id
                      )
                    "
                    *ngIf="definition.children.length > 0"
                    [(ngModel)]="currentDefinitions[definition.data.id]"
                    [defaultLabel]="
                      definition.data?.value +
                      ' (' +
                      definition.children?.length +
                      ')'
                    "
                    [disabled]="!editing"
                    [options]="definition.children"
                    dataKey="id"
                    display="chip"
                    filterMatchMode="contains"
                    optionDisabled="inactive"
                    optionLabel="data.value"
                    optionValue="data"
                  >
                  </p-multiSelect>
                </ng-container>
              </div>
            </ng-template>
          </ng-container>
        </div>
        <div
          *ngIf="
            selectedTarget === 1 ||
            selectedTarget === 4 ||
            (selectedTarget === 2 &&
              definition.data.value.toLowerCase() !== 'departments' &&
              definition.data.value.toLowerCase() !== 'department' &&
              definition.data.value.toLowerCase() !== 'categories' &&
              definition.data.value.toLowerCase() !== 'category' &&
              definition.data.value.toLowerCase() !== 'brands' &&
              definition.data.value.toLowerCase() !== 'brand')
          "
          class="col-2 md:col-1 text-center"
        >
          <button
            (click)="addDefinition(definition.data)"
            icon="pi pi-plus"
            pButton
            pRipple
            styleClass="p-button-primary ml-2"
            type="button"
          ></button>
        </div>
      </ng-container>
    </ng-container>
    <div class="col-12 md:col-11 mt-2">
      <div class="flex align-items-center justify-content-start">
        <div class="col-12 md:col-2 mt-2">
          <button
            (click)="addDefinition(null)"
            class="p-button p-button-secondary mr-2"
            icon="pi pi-plus"
            label="Definition"
            pButton
            pRipple
            type="button"
          ></button>
        </div>
      </div>
    </div>
    <div *ngIf="targetId && editing" class="col-12 md:col-11 mt-2">
      <div class="flex align-items-center justify-content-end">
        <div class="col-12 md:col-2 md:col-offset-2 mt-2">
          <button
            (click)="linkDefinitionsToTarget()"
            class="p-button flex align-items-center justify-content-end"
            label="Save"
            pButton
            pRipple
            type="button"
          ></button>
        </div>
      </div>
    </div>
  </div>

  <!-- END THE DROP DOWN VERSION -->

  <ng-container
    *ngIf="complexDefinitions && departmentsLoaded && categoriesLoaded"
  >
    <ng-container *ngIf="definitions.length > 0; else noDefinitions">
      <div class="card my-2 p-1">
        <div class="grid formgrid justify-content-center">
          <div class="col">
            <ul class="breadcrumb-list">
              <li *ngFor="let item of definitionIdTree; let i = index">
                <a (click)="loadChildDefinitions(item.id, i)">{{
                  item.label
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card">
        <p-treeTable
          (onNodeSelect)="nodeSelect($event)"
          [(selection)]="selectedNode"
          [columns]="cols"
          [lazy]="true"
          [value]="definitions"
          dataKey="id"
          selectionMode="single"
        >
          <ng-template let-columns pTemplate="header">
            <tr>
              <th *ngIf="isDeveloperMode">Raw</th>
              <th *ngFor="let col of columns">
                {{ col.header }}
              </th>
              <th><!-- actions --></th>
            </tr>
          </ng-template>
          <ng-template
            let-columns="columns"
            let-rowData="rowData"
            let-rowNode
            pTemplate="body"
          >
            <tr [ttRow]="rowNode" [ttRow]="rowNode" [ttSelectableRow]="rowNode">
              <td *ngIf="isDeveloperMode">{{ rowData | json }}</td>
              <td *ngFor="let col of columns; let i = index">
                <p-treeTableToggler
                  *ngIf="i == 0"
                  [rowNode]="rowNode"
                ></p-treeTableToggler>
                {{ rowData[col.field] }}
              </td>
              <td>
                <button
                  (click)="addDefinition(rowData)"
                  *ngIf="rowData.children"
                  class="p-button-rounded"
                  icon="pi pi-plus"
                  pButton
                  pRipple
                  pToolTip="Add an additional option under this definition"
                  type="button"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #noDefinitions>
  <p-messages severity="info">
    <ng-template pTemplate>
      <p>There are no definition defined yet, please create your first one.</p>

      <button
        (click)="addDefinition(null)"
        icon="pi pi-plus"
        label="Create Definition"
        pButton
        pRipple
        pToolTip="Add A Top Level Definition"
        type="button"
      ></button>
    </ng-template>
  </p-messages>
</ng-template>

<p-dialog
  [(visible)]="displayDialogue"
  [header]="!this.selectedDefinition ? 'Create Parent' : 'Create Definition'"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <form
    class="formgrid grid"
    *ngIf="!awaitingResponse; else loading"
    [formGroup]="createFormGroup"
  >
    <div class="grid formgrid justify-content-center">
      <div class="col">
        <div class="formgrid grid">
          <div class="field col-12">
            <label>
              {{ !this.selectedDefinition ? 'Parent' : 'Definition' }}
              Name:
            </label>
            <div class="p-inputgroup">
              <span
                *ngIf="showAdvancedCreationOptions"
                class="p-inputgroup-addon"
              >
                <p-checkbox
                  [binary]="true"
                  formControlName="isSelectable"
                  pTooltip="This definition will be used to tag items."
                >
                </p-checkbox
              ></span>
              <input
                formControlName="value"
                pInputText
                placeholder="Enter the name"
                required
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center">
      <div class="p-formgroup-inline align-items-center">
        <div class="field-checkbox mb-0 pb-0" style="display: none">
          <p-checkbox
            [(ngModel)]="showAdvancedCreationOptions"
            [binary]="true"
            inputId="advancedOption"
            name="advancedOption"
            pTooltip="Advanced Creation Options"
          >
          </p-checkbox>
          <label for="advancedOption">Advanced</label>
        </div>
      </div>
      <div>
        <p-button
          (click)="displayDialogue = false"
          icon="pi pi-times"
          label="Cancel"
          styleClass="p-button-text p-button-danger"
        ></p-button>
        <p-button
          (click)="createDefinition()"
          [disabled]="!createFormGroup.valid"
          icon="pi pi-check"
          label="Create Definition"
          styleClass="p-button-text p-button-primary"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="displayEditDialogue"
  [modal]="true"
  [style]="{ width: '650px' }"
  header="Edit Definition Titles"
>
  <div class="formgrid grid">
    <h3>Parent Definition</h3>

    <div class="field col-12">
      <div class="p-inputgroup">
        <input
          [value]="selectedDefinition?.value"
          id="definition-parent"
          pInputText
          type="text"
          class="w-full"
        />

        <button
          (click)="updateDefinitionTitle(selectedDefinition?.id, 'parent')"
          icon="pi pi-save"
          pButton
          pRipple
          styleClass="p-button-primary"
          type="button"
        ></button>
      </div>
    </div>

    <ng-container *ngIf="selectedDefinition?.children.length">
      <h3>Child Definitions</h3>
      <!-- FOR EACH CHILD SHOW EDIT FIELD ROW AND SAVE BUTTON -->
      <ng-container
        *ngFor="let child of selectedDefinition?.children; let i = index"
      >
        <div class="field col-12">
          <div class="p-inputgroup">
            <input
              [value]="child?.value"
              id="definition-{{ i }}"
              pInputText
              type="text"
            />

            <button
              (click)="updateDefinitionTitle(child?.id, i)"
              icon="pi pi-save"
              pButton
              pRipple
              styleClass="p-button-primary"
              type="button"
            ></button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</p-dialog>

<ng-template #loading>
  <boma-anim-spinning-loader [size]="40"></boma-anim-spinning-loader>
</ng-template>
